import { formatDate, parseISO } from "date-fns"
import { Badge } from "design-system/atoms/Badge"
import { Award } from "lucide-react"
import { useTranslation } from "react-i18next"
import { ConversationOpportunityResponseDataSchema } from "schema"
import z from "zod"

const OpportunityIcon = Award

type Props = {
  opportunity: z.infer<typeof ConversationOpportunityResponseDataSchema>
}

export function OpportunityContent({ opportunity }: Props) {
  const { t } = useTranslation()

  const qualificationLabel = t(
    `conversations.opportunities.qualification.${opportunity.qualification}`,
  )

  return (
    <div className="w-full flex flex-col gap-4">
      <div className="w-full flex flex-col sm:flex-row gap-4 justify-between text-chart-1">
        <div className="flex gap-1 items-center">
          <OpportunityIcon size={16} />
          <span className="text-sm font-medium">
            {t("conversations.opportunities.timeline.opportunity")}
          </span>
        </div>
        <div className="flex flex-row gap-4 items-center">
          <Badge variant="secondary">
            <span>{qualificationLabel}</span>
          </Badge>
          {opportunity.escalatedAt && (
            <Badge variant="outline">
              <span>{t("conversations.opportunities.timeline.escalated")}</span>
            </Badge>
          )}
          <span className="text-xs text-muted-foreground">
            {formatDate(parseISO(opportunity.createdAt), "Pp")}
          </span>
        </div>
      </div>
      <div className="overflow-hidden text-left text-sm border border-border rounded-lg p-4">
        {opportunity.summary || t("conversations.opportunities.timeline.noSummary")}
      </div>
    </div>
  )
}
